const v2edit = () => {
    return $('#virta-admin-pricing-content').data('v2edit') === 1;
}
export {v2edit};